import { WSPageToolbarAction } from "@wingspanhq/fe-component-library";
import {
  BiometricIdentityVerificationRequest,
  BiometricIdentityVerificationRequestStatus
} from "@wingspanhq/wingspan-api-sdk";

import { getRequirementDefinitionTableCellProps } from "../../../../../RequirementDefinitions/utils";
import {
  CellsConfig,
  ContextItem,
  RequirementContextType,
  RequirementTableCallback,
  RequirementTableItemData
} from "../../../../types";
import { getRequirementEngagementsTableCellProps } from "../../../../utils";
import { IdentityVerificationDetailsWidgetsContainer } from "../../components/IdentityVerificationDetailsWidgetsContainer";
import { getIdentityVerificationPayeeProgressSteps } from "../helpers/getIdentityVerificationPayeeProgressSteps";
import { getIdentityVerificationPayerRequirementStatus } from "../helpers/getIdentityVerificationPayerRequirementStatus";
import { getIdentityVerificationRequirementName } from "../helpers/getIdentityVerificationRequirementName";
import { IDENTITY_VERIFICATION_IN_FLIGHT_STATUSES } from "../utils";

import { payeeIdentityVerificationRenderCardDescription } from "./payeeIdentityVerificationRenderCardDescription";

export const usePayeeIdentityVerificationConfig = (
  callback: RequirementTableCallback
): CellsConfig<
  RequirementTableItemData,
  ContextItem,
  BiometricIdentityVerificationRequest | undefined
> => {
  return {
    isActionRequired: () => {
      return false;
    },
    requirementDetailsProgressWidget: (
      requirement,
      context,
      identityVerification
    ) => {
      return identityVerification?.status
        ? getIdentityVerificationPayeeProgressSteps(identityVerification.status)
        : undefined;
    },
    requirementDetailsWidgets: (requirement, context, identityVerification) => {
      return identityVerification ? (
        <IdentityVerificationDetailsWidgetsContainer
          contextType={RequirementContextType.Payee}
          identityVerification={identityVerification}
          requirement={requirement}
          onSuccess={callback}
        />
      ) : null;
    },
    requirementStatusAlert: (requirement, context, identityVerification) => {
      if (
        IDENTITY_VERIFICATION_IN_FLIGHT_STATUSES.includes(
          identityVerification?.status
        )
      ) {
        return {
          theme: "info",
          title: "Awaiting contractor",
          icon: "time",
          children: "Awaiting contractor to complete the requirement."
        };
      }
    },
    requirementName: getIdentityVerificationRequirementName,
    requirementDetails: (requirement, context, identityVerification) => {
      return {
        header: {
          label: {
            text: "Identity verification"
          },
          value: {
            pill:
              identityVerification?.status ===
              BiometricIdentityVerificationRequestStatus.FAILED
                ? {
                    theme: "error",
                    text: "Failed",
                    icon: true
                  }
                : undefined
          }
        },
        children: payeeIdentityVerificationRenderCardDescription(
          requirement,
          identityVerification
        ),
        data: [],
        actions: undefined
      };
    },
    toolbarActions: () => {
      const actions: WSPageToolbarAction[] = [];

      return actions;
    },
    nameCell: (requirement, context, identityVerification) => {
      return {
        text: getIdentityVerificationRequirementName(
          requirement,
          context,
          identityVerification
        )
      };
    },
    typeCell: requirement =>
      getRequirementDefinitionTableCellProps({
        type: requirement.type
      }),
    statusCell: (requirement, context, identityVerification) => {
      return getIdentityVerificationPayerRequirementStatus(
        requirement,
        context,
        identityVerification
      );
    },
    engagementsCell: getRequirementEngagementsTableCellProps
  };
};
